import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useResultsStore = defineStore('results', () => {

    const listings = ref();
    const loading = ref(true);
    const pageInfo = ref();
    const activeQueries = ref(0);
    const hasErrored = ref(false);

    function incrementActiveQueries() {
        activeQueries.value++;

        setLoading(true);
    }

    function decrementActiveQueries() {

        if (activeQueries.value === 0) {

            return;

        }

        activeQueries.value--;

    }

    function setLoading(status) {

        loading.value = status;

    }

    function updateResults(results) {

        decrementActiveQueries();

        if (activeQueries.value === 0) {

            if (!results.data) {

                hasErrored.value = true;

                setLoading(false);

                return;

            }

            listings.value = results.data.paginatedListings.edges;

            pageInfo.value = results.data.paginatedListings.pageInfo;

            setLoading(false);

        }

    }

    return {
        listings,
        loading,
        hasErrored,
        pageInfo,
        activeQueries,
        incrementActiveQueries,
        decrementActiveQueries,
        setLoading,
        updateResults,
    }

})

